import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Exported so `index.test.ts` can call it directly: `beforeLoad`'s generic
 * context type is needlessly heavy to fabricate in a test for a redirect
 * that doesn't read it.
 *
 * This is the landing target for the advertised participant CTA, which
 * carries UTM/click-ID params (see `@/schemas/utm`) for the capture code
 * downstream to pick up. Keep them on the redirect rather than dropping
 * them here before any capture code runs (PX-274).
 */
export function redirectToParticipantsProjects(): never {
  throw redirect({ to: '/participants/projects', search: true });
}

export const Route = createFileRoute('/participants/')({
  beforeLoad: redirectToParticipantsProjects,
});
